export const MERGE_FIELD_SAMPLES = {
  genre: 'Mr.',
  noms: 'AMADOU MOUSSA DAOUDA',
  domaine: 'Finance',
  specialite: 'Business acquisition',
  lieuNaissance: 'Libreville',
  dateNaissance: 'July 14, 1986',
  anneeAcademique: '2024-2025',
  mention: 'Excellent',
  pronoun: 'him',
  numeroRef: 'D204',
  lieuEmission: 'Port-au-Prince',
  dateEmission: 'October 27, 2025',
};

export const MERGE_FIELDS = [
  { key: 'genre', label: 'Genre (Mr./Ms.)' },
  { key: 'noms', label: 'Nom complet' },
  { key: 'domaine', label: 'Domaine' },
  { key: 'specialite', label: 'Spécialisation' },
  { key: 'lieuNaissance', label: 'Lieu de naissance' },
  { key: 'dateNaissance', label: 'Date de naissance' },
  { key: 'anneeAcademique', label: 'Année académique' },
  { key: 'mention', label: 'Mention' },
  { key: 'pronoun', label: 'Pronom (him/her)' },
  { key: 'numeroRef', label: 'N° de référence' },
  { key: 'lieuEmission', label: "Lieu d'émission" },
  { key: 'dateEmission', label: "Date d'émission" },
];

const MERGE_TOKEN_RE = /\{\{(\w+)\}\}/g;

export const createMergeFieldElement = (key, previewMode = true) => {
  const span = document.createElement('span');
  span.className = 'cierha-merge-field';
  span.contentEditable = 'false';
  span.dataset.var = key;
  span.setAttribute('data-var', key);
  const field = MERGE_FIELDS.find((f) => f.key === key);
  const label = field?.label || key;
  const display = previewMode
    ? (MERGE_FIELD_SAMPLES[key] || label)
    : `{{${key}}}`;
  span.textContent = display;
  span.title = `Champ: ${label}`;
  return span;
};

export const textToEditableHtml = (text, previewMode = true, allowMergeFields = true) => {
  if (!text) return '';
  if (!allowMergeFields) {
    return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  const parts = text.split(MERGE_TOKEN_RE);
  const frag = document.createDocumentFragment();

  parts.forEach((part, index) => {
    if (index % 2 === 0) {
      if (part) frag.appendChild(document.createTextNode(part));
    } else if (MERGE_FIELDS.some((f) => f.key === part)) {
      frag.appendChild(createMergeFieldElement(part, previewMode));
    } else {
      frag.appendChild(document.createTextNode(`{{${part}}}`));
    }
  });

  const container = document.createElement('div');
  container.appendChild(frag);
  return container.innerHTML;
};

export const serializeEditable = (element) => {
  if (!element) return '';

  const walk = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return '';

    if (node.classList?.contains('cierha-merge-field')) {
      return `{{${node.dataset.var}}}`;
    }

    const tag = node.tagName.toLowerCase();
    const inner = Array.from(node.childNodes).map(walk).join('');

    if (tag === 'strong' || tag === 'b') return `<strong>${inner}</strong>`;
    if (tag === 'em' || tag === 'i') return `<em>${inner}</em>`;
    if (tag === 'u') return `<u>${inner}</u>`;
    if (tag === 'br') return '\n';
    if (tag === 'div' || tag === 'p') return `${inner}\n`;

    return inner;
  };

  return Array.from(element.childNodes)
    .map(walk)
    .join('')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

export const applyMergeTemplate = (templateStr, data) => {
  if (!templateStr) return '';
  return templateStr.replace(MERGE_TOKEN_RE, (_, key) => {
    const value = data[key];
    return value != null && value !== '' ? String(value) : '';
  });
};

export const buildMergeData = (docData, formatDateFn) => {
  const title = docData.genre === 'Femme' ? 'Ms.' : 'Mr.';
  const pronoun = docData.genre === 'Femme' ? 'her' : 'him';
  return {
    genre: title,
    noms: docData.noms || '',
    domaine: docData.domaine || '',
    specialite: docData.specialite || '',
    lieuNaissance: docData.lieuNaissance || '',
    dateNaissance: formatDateFn(docData.dateNaissance),
    anneeAcademique: docData.anneeAcademique || '',
    mention: docData.mention || '',
    pronoun,
    numeroRef: docData.numeroRef || '',
    lieuEmission: docData.lieuEmission || 'Port-au-Prince',
    dateEmission: formatDateFn(docData.dateEmission),
  };
};

export const insertMergeFieldAtCursor = (fieldKey) => {
  const selection = window.getSelection();
  if (!selection?.rangeCount) return false;

  const range = selection.getRangeAt(0);
  range.deleteContents();

  const field = createMergeFieldElement(fieldKey, true);
  const space = document.createTextNode('\u00A0');

  range.insertNode(space);
  range.insertNode(field);

  range.setStartAfter(space);
  range.collapse(true);
  selection.removeAllRanges();
  selection.addRange(range);
  return true;
};
